import { jsx } from "react/jsx-runtime";
import { ChatBubble } from "@pcln/horizon";
import "react";
import { VoteType } from "../../chatTypes.js";
import { useMessageFeedback } from "../../hooks/useMessageFeedback.js";
import { useSafeDateString } from "../../hooks/useSafeDateString.js";
const PennyChatBubble = ({ message, children })=>{
    const { submitFeedback } = useMessageFeedback(message);
    return /*#__PURE__*/ jsx(ChatBubble, {
        role: "response",
        showResponseIcon: true,
        showVote: true,
        canToggleVote: false,
        dateString: useSafeDateString(message?.date),
        onIconClick: {
            thumbsUp: ()=>submitFeedback(VoteType.UP),
            thumbsDown: ()=>submitFeedback(VoteType.DOWN)
        },
        slots: {
            wrapperSlot: 'pb-1',
            containerSlot: '',
            contentSlot: '',
            responseIconSlot: '',
            footerSlot: ''
        },
        children: children
    });
};
const PennyChatBubble_PennyChatBubble = PennyChatBubble;
export { PennyChatBubble_PennyChatBubble as default };
